import { Component, OnInit } from '@angular/core';
import { GeneralService } from '../general.service';
import { FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-request-certificate-edit',
  templateUrl: './request-certificate-edit.component.html',
  styleUrls: ['./request-certificate-edit.component.css']
})
export class RequestCertificateEditComponent implements OnInit{
  constructor(private s:GeneralService, private fb:FormBuilder, private tstr:ToastrService, private act:ActivatedRoute){}
  ngOnInit(): void {
    this.form.controls.policyNumber.setValue(this.act.snapshot.params['id'])
    this.form.controls.policyNumber.disable()
  }
  form = this.fb.group(
    {
      comment:['',Validators.required],
      policyNumber:['', Validators.required]
  })
  submit(){
    console.log(this.form.value)
    this.s.requestEdit(this.form.value)
    .subscribe((r)=>{
      this.s.loader = false
      this.tstr.success("Your request was successfully submitted")
      this.form.controls.comment.reset()
      this.form.controls.policyNumber.reset()
    })
  }

}
